class StickyCollectionBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const filter = this.querySelector('.clp__filter');
    const sentinel = this.querySelector('.clp__sentinel');
    const header = document.querySelector('.header');
    const filterLinks = this.querySelectorAll('.clp__filter-list a');
    const cards = this.querySelectorAll('.clp__card');

    // ===== Sticky Filter Bar Logic =====
    if (filter && sentinel && header) {
      const updateStickyTop = () => {
        const isMobile = window.innerWidth < 960;
        const headerHeight = header.offsetHeight - (isMobile ? 8 : 24);
        filter.style.setProperty('--sticky-top', `${headerHeight}px`);
        return headerHeight;
      };

      let headerHeight = updateStickyTop();

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) {
            headerHeight = updateStickyTop();
            document.body.classList.add('sticky_bar');
            filter.classList.add('clp__filter--sticky');
          } else {
            document.body.classList.remove('sticky_bar');
            filter.classList.remove('clp__filter--sticky');
          }
        },
        {
          rootMargin: `-${headerHeight}px 0px 0px 0px`,
          threshold: 0,
        }
      );

      observer.observe(sentinel);

      window.addEventListener('resize', () => {
        headerHeight = updateStickyTop();
      });
    }

    // ===== Filter Functionality =====
    function getLetterFromUrl() {
      const query = new URLSearchParams(window.location.search);
      const firstKey = query.searchParams.get('letter');
      return firstKey || 'all';
    }

    function filterByLetter(letter) {
      filterLinks.forEach(link => {
        const isActive = link.dataset.letter === letter || (letter === 'all' && link.dataset.letter === 'all');
        link.classList.toggle('active', isActive);
      });

      const FADE_OUT_DURATION = 200;
      const FADE_IN_DURATION = 700;

      const toHide = [];
      const toShow = [];

      cards.forEach(card => {
        const cardLetter = card.dataset.letter;
        const shouldShow = letter === 'all' || cardLetter === letter;

        if (shouldShow && card.style.display === 'none') {
          toShow.push(card);
        } else if (!shouldShow && card.style.display !== 'none') {
          toHide.push(card);
        }
      });

      // Step 1: Fade out old cards
      toHide.forEach(card => {
        card.classList.add('fade-out');
      });

      // After fade out ends, hide the cards and fade in new ones
      setTimeout(() => {
        // Actually hide the faded-out cards
        toHide.forEach(card => {
          card.style.display = 'none';
          card.classList.remove('fade-out');
        });

        // Step 2: Fade in new cards
        toShow.forEach(card => {
          card.style.display = ''; // show first (hidden by display)
          card.classList.add('fade-in');
          requestAnimationFrame(() => {
            card.classList.add('show');
          });

          setTimeout(() => {
            card.classList.remove('fade-in', 'show');
          }, FADE_IN_DURATION);
        });

      }, FADE_OUT_DURATION);

    }

    filterLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const selectedLetter = this.dataset.letter;
        const paramKey = selectedLetter === 'all' ? '' : `${selectedLetter}`;
        const newUrl = paramKey ? `${window.location.pathname}?${paramKey}` : window.location.pathname;
        history.pushState(null, '', newUrl);
        filterByLetter(selectedLetter);
      });
    });

    const initialLetter = getLetterFromUrl();
    filterByLetter(initialLetter);

    window.addEventListener('popstate', () => {
      const letter = getLetterFromUrl();
      filterByLetter(letter);
    });
  }
}

if (!customElements.get('custom-collection')) {
  customElements.define('custom-collection', StickyCollectionBar);
}
